import { Component, DoCheck, OnInit } from '@angular/core';
import { FooterLabel_EN } from '../../../models/labels/footerLabel_EN';
import { LoginRenderingService } from '../../../services/login/login-rendering.service';
import { ApiService } from '../../../services/api/api.service';
import { MatDialogConfig, MatDialog } from '@angular/material';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { BorrowerRenderingService } from 'src/app/services/borrower/borrower-rendering.service';
import { FooterLabel_HN } from 'src/app/models/labels/footerLabel_HN';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, DoCheck {

  label: any;
  footerImg: String;
  constructor(private loginRenderingService: LoginRenderingService, private borrowerRenderingService: BorrowerRenderingService,
    private loginService: LoginRenderingService, private data: ApiService, public dialog: MatDialog) { }

  ngDoCheck(): void {
    if (this.borrowerRenderingService.language) {
      if (this.borrowerRenderingService.language === 'ENGLISH') {
        this.label = new FooterLabel_EN();
      } else if (this.borrowerRenderingService.language === 'HINDI') {
        this.label = new FooterLabel_HN();
      }
    } else {
      this.label = new FooterLabel_EN();
    }
  }

  ngOnInit() {
    if (this.borrowerRenderingService.language) {
      if (this.borrowerRenderingService.language === 'ENGLISH') {
        this.label = new FooterLabel_EN();
      } else if (this.borrowerRenderingService.language === 'HINDI') {
        this.label = new FooterLabel_HN();
      }
    } else {
      this.label = new FooterLabel_EN();
    }
  }

  public footerImage() {
    this.footerImg = this.data.setFooterImage();
    return this.footerImg;
  }

  openAbout() {
    const dialogConfig = new MatDialogConfig();
    // dialogConfig.panelClass = 'about';
    dialogConfig.autoFocus = false;
    this.dialog.open(AboutUsComponent, dialogConfig);
  }

  openPrivacy() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'about';
    dialogConfig.autoFocus = false;
    this.dialog.open(PrivacyComponent, dialogConfig);
  }

  openTerms() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'about';
    dialogConfig.autoFocus = false;
    this.dialog.open(TermsAndConditionsComponent, dialogConfig);
  }
}
